export default "__VITE_ASSET__CQQgj9fo__"